import { useCallback } from 'react';
import { useAppSelector } from 'store/store';
import { track, TrackedFeature, TrackedPage, TrackedUserInfo, TRACKING_PARAM_KEYS } from 'services/Logger';

export type TrackingParameters = Record<string, number | string | boolean | undefined>;

export const useLoggerTracking = () => {
    const user = useAppSelector(state => state.applicationContext.context?.user);

    return useCallback(
        (trackedPage: TrackedPage, trackedFeature: TrackedFeature, parameters?: TrackingParameters): Promise<void> => {
            const enrichedParameters: TrackingParameters = {
                ...parameters,
                [TRACKING_PARAM_KEYS.page]: trackedPage,
                [TrackedUserInfo.IcId]: user?.id,
                [TrackedUserInfo.IsInternal]: user?.isInternal,
                [TrackedUserInfo.Language]: user?.language,
            };

            return track(trackedFeature, enrichedParameters);
        },
        [user],
    );
};